window.matchMedia || (
  window.matchMedia = function () {
    return {
      matches: false,
      addListener() {},
      removeListener() {},
  };
});



// WEBPACK FOOTER //
// ./src/matchMedia.js